// import Proj3 from "../assets/proj3.webp";
import InfoCrypto from "../assets/InfoCrypto.jpg";
// import Proj5 from "../assets/proj5.jpg";
// import Proj6 from "../assets/proj6.png";
import Castielo from '../assets/Castielo.jpg'
import PersonalBlog from '../assets/PersonalBlog.jpg'

// const notFinishYet = "https://ksr-ugc.imgix.net/assets/011/588/630/0e8d143fb8ff1d7a57232daa3d8d38b9_original.jpg?ixlib=rb-4.0.2&crop=faces&w=1552&h=873&fit=crop&v=1463684883&auto=format&frame=1&q=92&s=c7c8a3665e9cea5e26b7cd0d49cd68e5"

export const ProjectList = [
  {
    name: "Personal Blog",
    image: PersonalBlog,
    skills: "React,Node.js,Express,MongoDB, html, css",
    github: "https://github.com/Inigo-Javier/Blog-Client",
    web: "https://blog-private.netlify.app/",
  },
  {
    name: "Castielo",
    image: Castielo,
    skills: "React, Express, Node, JavaScript, Bootstrap,HTML,CSS",
    github: "https://github.com/Inigo-Javier/Castielo-client",
    web: "https://castielo.netlify.app/inicio",
  },
  {
    name: "InfoCrypto Index",
    image: InfoCrypto,
    skills: "React,Ant Desing,Redux Toolkit,RapidApi",
    github: "https://github.com/Inigo-Javier/lab-express-drones",
    web: "https://informationcrypto.netlify.app/",
  },
  // {
  //   name: "Spotify Clone",
  //   image: Proj3,
  //   skills: "React,Node.js,MongoDB,SpotifyAPI",
  //   github: "https://github.com/Inigo-Javier/lab-express-drones",
  //   web: notFinishYet,
  // },
  // {
  //   name: "Dashboard Visualizer",
  //   image: Proj5,
  //   skills: "JavaScript,HTML,CSS",
  //   github: "https://github.com/Inigo-Javier/lab-express-drones",
  //   web: notFinishYet,
  // },
  // {
  //   name: "Mobile Game",
  //   image: Proj6,
  //   skills: "React Native,JavaScript,HTML,CSS",
  //   github: "https://github.com/Inigo-Javier/lab-express-drones",
  //   web: notFinishYet,}
];







  // {
  //   id: 1,
  //   title: "Rick and Morty character finder",
  //   description: "projects.rick-morty",
  //   image: RickMortyImg,
  //   skills: ["HTML", "SASS", "REACT"],
  //   githubLink: "https://github.com/crisgarm/rick-morty-characters-finder",
  //   webLink: "https://crisgarm.github.io/rick-morty-characters-finder/#/",
  //   githubAlt: "projects.rick-morty-github-alt",
  //   webAlt: "projects.rick-morty-web-alt",
  // }

